import React, { useState } from 'react';
import { View, Text, Image, TouchableOpacity } from 'react-native-web';
import * as Animatable from 'react-native-animatable';
import RenderHtml, { defaultHTMLElementModels, HTMLContentModel } from 'react-native-render-html';

// Child Components
import { Button } from '../../components';

// Configs
import GLOBAL from '../../configs/config_global';

// Root Navigation
import * as RootNavigation from '../../navigation/RootNavigation';
import routeKeys from '../../navigation/RouteKeys';

export default function ResourceTopicItem(props) {
    const { topicData = {}, index = 0 } = props;

    const DELAY_VALUE = 150;
    const PADDING_VALUE = 24;
    const PHOTO_SIZE = 150;

    // region Local State
    const [itemHTMLHeight, setItemHTMLHeight] = useState(0);
    const [containerWidth, setContainerWidth] = useState(0);
    // endregion

    // region Render Topic Link Button
    const renderTopicLinkButton = (link) => (
        !!link?.trim() &&
        <Button
            onPress={() => window.open(link, '_blank')}
            style={{
                width: 150, backgroundColor: 'white', borderWidth: 2, borderColor: GLOBAL.COLOR.DIVIDER,
                alignSelf: 'flex-start',
                marginTop: 24
            }}
            text={'Open'}
            textStyle={{ color: GLOBAL.COLOR.BASIC.BLACK_TWO }}
            image={'external-link'}
            imageSize={24}
            imageColor={GLOBAL.COLOR.BASIC.BLACK_TWO}
            imageStickToText={true}
            useFeather={true}
        />
    )
    // endregion

    // region MAIN RENDER
    return(
        <Animatable.View
            key={`topicItem_${topicData.id}`}
            animation={'fadeInUp'} duration={600} delay={index * DELAY_VALUE}
            style={{
                alignSelf: 'stretch', borderRadius: 8, borderWidth: 1, borderColor: GLOBAL.COLOR.DIVIDER,
                overflow: 'hidden', backgroundColor: 'white', padding: PADDING_VALUE, marginHorizontal: 24
            }}>
            <TouchableOpacity
                onPress={() => RootNavigation.push(routeKeys.RESOURCE_DETAILS, { topicData })}
                onLayout={(event) => !containerWidth && setContainerWidth(event.nativeEvent.layout.width)}
                style={{ width: '100%', flexDirection: 'row', alignItems: 'flex-start', backgroundColor: 'white' }}>
                {/* HTML Content */}
                <View style={{ flex: 1, marginRight: PADDING_VALUE, maxHeight: PHOTO_SIZE, overflow: 'hidden' }}>
                    {/* Name */}
                    {
                        !!topicData.name?.trim() &&
                        <Text style={{ fontSize: 16, fontWeight: '600', marginBottom: 16 }}>
                            {topicData.name}
                        </Text>
                    }

                    {/* Main HTML Renderer */}
                    <View
                        style={{ alignSelf: 'stretch' }}
                        onLayout={(event) => !itemHTMLHeight && setItemHTMLHeight(event.nativeEvent.layout.height)}>
                        <RenderHtml
                            contentWidth={containerWidth - (PADDING_VALUE * 2) - (topicData?.['featured_image'] ? (PHOTO_SIZE + PADDING_VALUE) : 0)}
                            source={{ html: !topicData.description.startsWith('<p>') ? topicData.description.replace(/(?:\r\n|\r|\n)/g, '<br>') : topicData.description }}
                            baseStyle={{ lineHeight: 26, fontSize: 16 }}
                            defaultTextProps={{ numberOfLines: 5, allowFontScaling: false }}
                            enableExperimentalBRCollapsing={true}
                            enableExperimentalGhostLinesPrevention={true}
                            customHTMLElementModels={{
                                'label': defaultHTMLElementModels.label.extend({ contentModel: HTMLContentModel.block }),
                                'colgroup': defaultHTMLElementModels.colgroup.extend({ contentModel: HTMLContentModel.block }),
                                'col': defaultHTMLElementModels.col.extend({ contentModel: HTMLContentModel.block })
                            }}
                        />
                    </View>

                    {/* Gradient */}
                    {
                        (itemHTMLHeight > PHOTO_SIZE) &&
                        <Image
                            source={require('../../images/image_gradient.png')}
                            style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 20 }}
                        />
                    }
                </View>

                {/* Photo */}
                {
                    !!topicData['featured_image'] &&
                    <Image
                        source={{ uri: topicData['featured_image'] }}
                        style={{ width: PHOTO_SIZE, height: PHOTO_SIZE }}
                        resizeMode={'cover'}
                    />
                }
            </TouchableOpacity>

            {/* CTA Button */}
            {renderTopicLinkButton(topicData['cta_link'])}
        </Animatable.View>
    );
    // endregion
}
